var render = function render(_c,_vm){return _c('div',[_c('b',[_vm._v("Error: "+_vm._s(_vm.props.errorMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }